/**
 * Created by ok on 7/14/17.
 */
import * as types from './actionTypes';

/**
 * Dispatches the Added to favorites action with
 * current date attached.
 *
 * @param patternid
 * @returns {function(*)}
 */
export const addToFavorites = (patternid, sewpatId, query) => ({
    type: types.ADDED_TO_FAVORITES,
    patternid,
    sewpatId,
    query: query || {},
    date: Date.now(),
});

export const removeFromFavorites = (patternid, sewpatId, query = {}) => ({
    type: types.REMOVED_FROM_FAVORITES,
    patternid,
    sewpatId,
    query,
});



// WEBPACK FOOTER //
// ./src/actions/favorites.js